import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { ApplicationStatus, RoutesName } from "@/shared/constants/enums";
import { formatFiatCurrency } from "@/shared/utils/amount-helpers";
import { DepositWithdrawalHistoryResponse } from "@/shared/repository/modules/deposit-withdrawal/repo";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    row: {
      type: <PropType<DepositWithdrawalHistoryResponse>>Object,
      required: true,
    },
  },
  emits: {
    depositWithdrawal: null,
    remove: null,
  },
  data() {
    return {
      depositWithdrawalRepo: this.$projectServices.depositWithdrawalRepo,
    };
  },
  computed: {
    displayedDateParts(): { date: string; time: string } {
      const [date, time = ""] = this.row.created_at
        .replace("T", " ")
        .split(" ");
      return { date, time: time.slice(0, 8) };
    },

    displayedStatus(): string {
      switch (this.row.status) {
        case ApplicationStatus.pending:
          return "Ожидает подтверждения";
        case ApplicationStatus.waiting:
          return "На проверке";
        case ApplicationStatus.inWork:
        case ApplicationStatus.progress:
          return "В обработке";
        case ApplicationStatus.reject:
        case ApplicationStatus.failed:
          return "Отклонено";
        case ApplicationStatus.completed:
        case ApplicationStatus.number3:
          return "Выполнено";
        default:
          return "Создано";
      }
    },

    displayedStatusTone(): string {
      switch (this.row.status) {
        case ApplicationStatus.completed:
        case ApplicationStatus.number3:
          return "completed";
        case ApplicationStatus.reject:
        case ApplicationStatus.failed:
          return "rejected";
        case ApplicationStatus.waiting:
          return "review";
        case ApplicationStatus.pending:
          return "pending";
        default:
          return "processing";
      }
    },

    displayedAmount(): string {
      return formatFiatCurrency(this.row.amount - this.row.commissions);
    },

    displayedSignedAmount(): string {
      return `${this.isDeposit ? "+" : "−"}${this.displayedAmount}`;
    },

    displayedCommission(): string {
      return formatFiatCurrency(this.row.commissions);
    },

    displayedApplicationType(): string {
      if (this.row.txID !== null) {
        return this.$t("Пополнение");
      }
      if (this.row.order_id !== null) {
        return this.$t("Вывод");
      }
      return this.isDeposit ? this.$t("Пополнение") : this.$t("Вывод");
    },

    displayedCurrencyCode(): string {
      // Крипто-записи в общей истории приходят без объекта currency,
      // валюта передаётся плоским полем coin.
      if (this.row.coin) {
        return this.row.coin.toUpperCase();
      }

      return this.row.currency.name.toUpperCase();
    },

    displayedCurrencySymbol(): string {
      const symbols: Record<string, string> = {
        RUB: "₽",
        USD: "$",
        EUR: "€",
        KZT: "₸",
        USDT: "₮",
        BTC: "₿",
      };
      return (
        symbols[this.displayedCurrencyCode] ??
        this.displayedCurrencyCode.slice(0, 1)
      );
    },

    isDeposit(): boolean {
      return this.row.app_type === "deposit";
    },

    isConfirmShow(): boolean {
      return this.row.status === ApplicationStatus.pending && !this.isDeposit;
    },

    isRemoveShow(): boolean {
      return this.row.status === ApplicationStatus.waiting;
    },
  },
  methods: {
    handleConfirm(): void {
      this.$router.push({ name: RoutesName.wallet });

      this.depositWithdrawalRepo.UPDATE_DEPOSIT({
        id: this.row.id,
        currency_id: this.row.currency_id,
        amount: this.row.amount,
        currencyName: this.row.currency.name,
      });
    },

    handleRemove(): void {
      this.$emit("remove", this.row.id);
    },

    handleRow(): void {
      this.$emit("depositWithdrawal", this.row);
    },
  },
});
